(function () {
    /**
     * The Enhanced Search
     * 
     * @module enhancedSearch
     */
    var enhancedSearch = {};
    var windowWidth = window.innerWidth;

    /**
     * Initialise the Enhanced Search listeners for keyboard navigation
     * 
     * @memberof module:enhancedSearch
     */
    enhancedSearch.init = function() { 
        var queryParam = new URLSearchParams(window.location.search).get('query');

        if (queryParam) {
            highlightSearchTerm(queryParam);
        }

        if(document.querySelector('.qld__search__facet-list')){
            setMobileView();
  
            window.addEventListener('resize', debounce(checkWindowResize, 100));
            var facetInputs = document.querySelectorAll('.qld__search__facet-list .qld__search__facet-input');

            for (var i = 0; i < facetInputs.length; i++) {
                facetInputs[i].addEventListener('change', function(){
                    const filterQuery = this.dataset.querystring;
                    if (this.checked) {
                        updateFilters(filterQuery, true);
                    } else {
                        updateFilters(filterQuery, false);
                    }
                })
            }

            var selectElement = document.querySelector(	
                ".qld__resources__select"	
            );	
            if (selectElement) {	
                selectElement.addEventListener("change", function () {	
                    var selectedOption = this.options[this.selectedIndex];	
                    var filterQuery = selectedOption.dataset.queryparam;	
                    updateLanguageFilters(filterQuery, true);	
                });	
            }

            var facetListButtons = document.querySelectorAll('.qld__search__facet-list .qld__search__facet-button--show');
            if (facetListButtons) {
                hideAdditionalFacetListItems(facetListButtons);
            }

            var filterCloseButtons = document.querySelectorAll('.qld__search__filters-list .qld__tag--filter-close');
            if (filterCloseButtons) {
                for (var i = 0; i < filterCloseButtons.length; i++) {
                    filterCloseButtons[i].addEventListener('click', event => {
                        const filterQuery = event.currentTarget.dataset.querystring;
                        updateFilters(filterQuery, false);
                    });
                };
            }

            var filterClearAll = document.querySelector('.qld__search__filters-list .qld__search__filter-tag--clear');
            if (filterClearAll) {
                filterClearAll.addEventListener('click', () => {
                    const currentQuery = window.location.search.replace('?','').split('&');
                    for (var i = 0; i < filterCloseButtons.length; i++) {
                        const filterQuery = filterCloseButtons[i].dataset.querystring;
                        currentQuery.forEach(function(query, index) {
                            if (query === filterQuery) {
                                currentQuery.splice(index, 1);
                            }
                        });
                    };
                    window.location.href = window.location.pathname + '?' + currentQuery.join('&');
                });
            }
        };
    }

    function highlightSearchTerm(queryParam) {
        var pageContent = document.querySelectorAll('.qld__search__result-header a, .qld__search__result-header .qld__breadcrumbs li, .qld__search__result-summary');

        for (var i = 0; i < pageContent.length; i++) { 
            var content = pageContent[i].textContent;
            var wrappedContent = content.replace(new RegExp(queryParam, 'gi'), '<strong>$&</strong>');

            if (content !== wrappedContent) {
                pageContent[i].innerHTML = wrappedContent;
            }
        };
    }

    function hideAdditionalFacetListItems(showButtons) {
        for (var i = 0; i < showButtons.length; i++) {   
            if (!showButtons[i].classList.contains('hidden')) {
                var facetList = showButtons[i].closest('.qld__search__facet-list');
                var facetListItems = facetList.querySelectorAll('li');
                if (facetListItems.length > 8) {
                    for (var j = 8; j < facetListItems.length; j++) {
                        facetListItems[j].classList.add('hidden');
                    }
                    toggleDisplayFacetListItems(showButtons[i], facetListItems);
                }
            }
        };
    }

    function toggleDisplayFacetListItems(showButton, listItems) {
        showButton.addEventListener('click', function(){
           var currentButton = this;
           currentButton.classList.add('hidden');
           var hideButton = currentButton.nextElementSibling;
           hideButton.classList.remove('hidden');
           for (var i = 7; i < listItems.length; i++) {
                listItems[i].classList.remove('hidden');
            }
            hideButton.addEventListener('click', function(){
                currentButton.classList.remove('hidden');
                this.classList.add('hidden');
                for (var i = 7; i < listItems.length; i++) {
                    listItems[i].classList.add('hidden');
                }
            })
        })
    }

    function updateFilters(filterQuery, state) {  
        var currentQuery = window.location.search.replace('?','').split('&');

        if (state) {
            window.location.href = currentQuery.push(filterQuery);
        } else {
            currentQuery.forEach(function(query, index) {
                if (query === filterQuery) {
                    currentQuery.splice(index, 1);
                }
            });
        }

        window.location.href = window.location.pathname + '?' + currentQuery.join('&');
    }

    function updateLanguageFilters(filterQuery, state) {	
        var currentQuery = window.location.search.replace("?", "").split("&");	
        if (state) {	
            var filterExists = false;	
            currentQuery.forEach(function (query, index) {	
                if (query.startsWith(filterQuery.split("=")[0])) {	
                    currentQuery[index] = filterQuery;	
                    filterExists = true;	
                }	
            });	
            if (!filterExists) {	
                currentQuery.push(filterQuery);	
            }	
        } else {	
            currentQuery.forEach(function (query, index) {	
                if (query.startsWith(filterQuery.split("=")[0])) {	
                    currentQuery.splice(index, 1);	
                }	
            });	
        }	
        window.location.href = window.location.pathname + "?" + currentQuery.join("&");
    }

    function checkWindowResize() {
        var newWidth = window.innerWidth;

        if (windowWidth > 991 && newWidth < 992) {
            setMobileView();
        }

        windowWidth = newWidth;
    }

    function setMobileView() {
        if (window.innerWidth < 992) {
            var accordionButtons = document.querySelectorAll('.qld__search__facet-title.qld__accordion__title');
            for (var i = 0; i < accordionButtons.length; i++) {
                accordionButtons[i].setAttribute('aria-expanded', false);
                accordionButtons[i].classList.remove('qld__accordion--open');
                accordionButtons[i].classList.add('qld__accordion--closed');
                accordionButtons[i].nextElementSibling.classList.remove('qld__accordion--open');
                accordionButtons[i].nextElementSibling.classList.add('qld__accordion--closed');
            }
        }
    }

    function debounce(func, delay) {
        let timerId;
        
        return function(...args) {
          clearTimeout(timerId);
          
          timerId = setTimeout(() => {
            func.apply(this, args);
          }, delay);
        };
    }
      

    document.addEventListener('DOMContentLoaded', function () {
        enhancedSearch.init();
    });
}());